// Global Dependencies
import 'react-select/dist/react-select.css';
import jsonLogic from 'json-logic-js-enhanced';

// Local
import ReactJsonLogic from './components/Master';

export const applyLogic = jsonLogic.apply;

export default ReactJsonLogic;



// WEBPACK FOOTER //
// ./src/index.jsx